jPar.loginAndRegistration.util = jPar.loginAndRegistration.util || {};
$j.extend(true, jPar.loginAndRegistration, {
	util: {
		showLoadingAnimation: function showLoadingAnimation() {
			$j('#wrapperForLoadingAnimation').addClass('hidden');
			$j('#loadingText').addClass('is-visible');
			$j('#regFormSubmit').attr('disabled', true);
		},

		hideLoadingAnimation: function hideLoadingAnimation() {
			$j('.directSocialSignOn').removeClass('directSocialSignOn');
			$j('#wrapperForLoadingAnimation').removeClass('hidden');
			$j('#loadingText').removeClass('is-visible');
			$j('#regFormSubmit').attr('disabled', false);
		},
	},
});
